import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { parseCompany } from "./company-parse-functions";

@Injectable()
export class SearchCompanyParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    const pageableResult: PageableResult = new PageableResult();
    const companyList: Company[] = [];
    if (payload) {
      pageableResult.setStart(payload.Start);
      pageableResult.setEnd(payload.TotalPerPages);
      pageableResult.setTotalItems(payload.Total);
      payload.Data.forEach((companyData) => {
        const company = parseCompany(companyData);
        companyList.push(company);
      });
      pageableResult.setItems(companyList);
    }
    return pageableResult;
  }
}
